type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'Advertisement'
const nameSource = 'commercial/advertisements'
const namePageTitle = 'Anúncios'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Anúncios',
  to: '/commercial/advertisements',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/advertisements/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/advertisements/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/advertisements/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
